const mcoTitles = [{
        cName: "APPLICATION FOR ORIGINAL FLORIDA TITLE using MCO",
        oSubMenu: [{
                cName: "VEHICLE, Private Use, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE",
                cReturn: "VEHICLE, Private Use, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE|75.25|1"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Auto (not Pickup or Truck), MCO APPLICATION FOR ORIGINAL FLORIDA TITLE",
                cReturn: "VEHICLE, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE, Lease or For Hire, Auto|54.25|6"
            },
            {
                cName: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc), MCO APPLICATION FOR ORIGINAL FLORIDA TITLE",
                cReturn: "VEHICLE, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc)|75.25|1"
            },
            {
                cName: "MOBILE HOME, Private or Lease, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE,",
                cReturn: "MOBILE HOME, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE|76.25|4"
            },
            {
                cName: "RECREATIONAL VEHICLE, Private Use, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE",
                cReturn: "RECREATIONAL VEHICLE, Private Use, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE|76.25|1"
            },
            {
                cName: "RECREATIONAL VEHICLE, Lease or For Hire, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE",
                cReturn: "RECREATIONAL VEHICLE, Lease or For Hire, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE|55.25|6"
            },
            {
                cName: "VESSEL, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE,",
                cReturn: "VESSEL, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE|5.25|5"
            },
            {
                cName: "OFF-HIGHWAY VEHICLE, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE, with title decal",
                cReturn: "OFF-HIGHWAY VEHICLE, MCO APPLICATION FOR ORIGINAL FLORIDA TITLE, with title decal|42.50|7"
            },
            {
                cName: "TRAILER < 1999 lbs - No Title required",
                bEnabled: false,
                cReturn: "Trailer < 1999 lbs - No Title required|0.00|2"
            },
            {
                cName: "Moped - No Title required",
                bEnabled: false,
                cReturn: "Moped - No Title required| 0.00|2"
            },
            {
                cName: "Motorcycle < 2 BHP and 50 CC - No Title required",
                bEnabled: false,
                cReturn: "Motorcycle < 2 BHP and 50 CC - No Title required |0.00|2"
            },
            {
                cName: "Motorized Bicycle - No Title required",
                bEnabled: false,
                cReturn: "Motorized Bicycle - No Title required|0.00|2"
            }
        ]
    }];

module.exports = mcoTitles;



// WEBPACK FOOTER //
// ./src/modules/data/mco-titles.js